import React, { FC } from 'react';
import { Text, TextTypography as TYPOGRAPHY } from '@wix/wix-ui-tpa/cssVars';
import { classes } from './ServiceNumber.st.css';

export type ServiceNumberProps = {
  index: number;
};

export const ServiceNumber: FC<ServiceNumberProps> = ({ index }) => {
  const formattedNumber = String(index + 1).padStart(2, '0') + '.';

  return (
    <div className={classes.root}>
      <Text className={classes.number} typography={TYPOGRAPHY.runningText}>
        {formattedNumber}
      </Text>
    </div>
  );
};
